import React, { useEffect, useMemo } from "react";
import { Fragment } from "react";
import {
  Badge,
  Button,
  Col,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  InputGroup,
  InputGroupText,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalBody,
  ModalHeader,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Spinner,
  Table,
  Toast,
  ToastBody,
  ToastHeader,
} from "reactstrap";
import Breadcrumb from "../../components/Common/Breadcrumb";
import { GetCookieData, GetCookieToken } from "../Cookie/GetCookie";
import axios from "axios";
import { useState } from "react";
import LoadingPage from "../TESTPage/LoadingPage";
import FadeIn from "react-fade-in/lib/FadeIn";
import dayjs from "dayjs";
import EvaluateForm from "./EvaluateForm";
import ViewEvaluate from "./ViewEvaluate";
import EditEvaluateForm from "./EditEvaluateForm";
import { FetchAxiosGet, FetchAxiosPost, FetchAxiosPut } from "../../api/axios";
import LoadingData from "../TESTPage/LoadingData";
import styled from "@emotion/styled";
import { keyframes } from "styled-components";
import Select from 'react-select';
import { HistoryEvaluate, SortEvaluate } from "./SortAndHistory";
import { useNavigate } from "react-router-dom";
import { CheckPosition } from "../Function/CheckPosition";
import { CheckSubAdmin } from "../Function/CheckSubAdmin";
import ConfirmModal from "../../components/Common/ConfirmModal";
import { checkEvaluateStaus, getScoreLevelConfig } from "./evaluateConfig";
import { exportEvaluateExcel } from "./ExportEvaluateExcel";

const API_URL = process.env.REACT_APP_API_CORS;

function TabledataCommander(props) {
  const { userInfo, conditon_for_admin = true } = props
  const token = GetCookieToken("userToken");
  const userData = GetCookieData("userData");
  const userPosition = GetCookieData("userPosition");
  const filterSubAdmin = userData.positionSubAdmin.map(i => i.type_sub_admin);
  const navigate = useNavigate();
  const [evaluateData, setEvaluateData] = useState([]);
  const [checkButtonAcceptArray, setCheckButtonAcceptArray] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingdata, setLoadingdata] = useState(true);
  const [open, setOpen] = useState(false);
  const [dataSelect, setDataSelect] = useState(new Date().getFullYear() + 543 + 1);
  const [roundYear, setRoundYear] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [dataInfo, setDataInfo] = useState([]);
  const [userOpition, setUserOpition] = useState([]);
  const [sectionFrom, setSectionFrom] = useState(false);
  const [checkboxApprov, setCheckboxApprov] = useState([]);
  const [sectionViewFrom, setSectionViewFrom] = useState(false);
  const [sectionEditFrom, setSectionEditFrom] = useState(false);
  const [evaluateFormID, setEvaluateFormID] = useState(null);
  const [checkButtonAccept, setCheckButtonAccept] = useState(true);
  const [approveEvaluateuserID, setApproveEvaluateuserID] = useState(null);
  const [approveEvaluateSalaryID, setApproveEvaluateSalaryID] = useState(null);
  const [evaluateSalaryFormID, setEvaluateSalaryFormID] = useState(null);
  const [showDataTable, setShowDataTable] = useState(true);
  const [userYear, setUserYear] = useState(null);
  const [userRound, setUserRound] = useState(null);
  const [departmentID, setDepartmentID] = useState(null);
  const [approvUser, setApprovUser] = useState(null)
  const [approvVersion, setApprovVersion] = useState(null)
  const [approvSendback, setApprovSendback] = useState(null)
  const [approvEvaluateStatus, setApprovrEvaluateStatus] = useState(null)
  const [updateApprove, setUpdateApprove] = useState([]);
  const [evaluateSalaryLink, setEvaluateSalaryLink] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [budgetAndRound, setBudgetAndRound] = useState([]);
  const [kongSort, setKongSort] = useState(false);
  const [filterLevel, setFilterLevel] = useState(false);
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;
  const OctMonth = new Date(new Date().getFullYear() - 1, 9).getMonth() + 1;
  const [userIdLekha, setUserIdLekha] = useState(null);
  const [historyEvaluates, setHistoryEvaluates] = useState([])
  const [historyDataTable, setHistoryDataTable] = useState([])
  const [orgOptions, setOrgOptions] = useState([]);
  const [filterSection, setFilterSection] = useState(null)
  const [confirmModalState, setConfirmModalState] = useState("");
  const [confirmModal, setConfirmModal] = useState(false);
  const [evaluateDataItem, setEvaluateDataItem] = useState(null);
  const [thisEvaluateUserId, setThisEvaluateUserId] = useState()
  const [exportLoading, setExportLoading] = useState(false);
  const [exportFilter, setExportFilter] = useState({ order: "show_score", sort: "DESC", filtered: undefined, task: "" });

  const isAdminView =
    conditon_for_admin && filterSubAdmin.length > 0 && (Number(filterSubAdmin) === 0 || Number(filterSubAdmin) === 3);

  const fecthHistoryDataTable = async () => {
    const urlCheckRound = `${API_URL}/api/evaluateSalary/checkRound`;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    await axios.get(urlCheckRound, config).then(response => {
      setBudgetAndRound(response.data.result);
      const url = `${API_URL}/api/evaluateSalaryHistory/datatable`;
      const params = new URLSearchParams({
        page: currentPage,
        size: 1000,
        "order[0]": "evaluate_salary_history_id",
        "order[1]": "ASC",
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      axios
        .get(url, config)
        .then(async response => {
          setHistoryDataTable(response.data.result)
        })
        .catch((error) => console.error("Error:", error));
    });
  }

  useEffect(() => {
    fecthHistoryDataTable()
  }, [])

  const fetchEvaluate = async (id, order = "show_score", sort = "DESC", filtered = undefined, task = "") => {
    const urlCheckRound = `${API_URL}/api/evaluateSalary/checkRound`;
    const config = { headers: { Authorization: `Bearer ${token}` } };
    await axios.get(urlCheckRound, config).then(async response => {
      setBudgetAndRound(response.data.result);
      const url = `${API_URL}/api/evaluateSalaryApprove/datatable`;
      let params
      if (filtered === undefined) {
        params = new URLSearchParams({
          page: currentPage,
          size: 10,
          "order[0]": order,
          "order[1]": sort,
          "filter[budget_year][0]": response.data.result.this_budget_year,
          "filter[round][0]": response.data.result.this_round,
          "filter[approve_user_id][0]": id,
        });
      } else {
        params = new URLSearchParams({
          page: currentPage,
          size: 10,
          "order[0]": order,
          "order[1]": sort,
          "filter[budget_year][0]": response.data.result.this_budget_year,
          "filter[round][0]": response.data.result.this_round,
          "filter[approve_user_id][0]": id,
          [`filter[${task}][0]`]: filtered,
        });
      }
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      await axios
        .get(url, config)
        .then(async (response) => {
          setDataInfo(() => response.data.info);
          setTotalPages(Math.ceil(response.data.info.totalRows / 10));

          await response.data.result.map(async item => {
            // await fecthStatus(item.user_id, item.budget_year, item.round)
            await fetchPositionLekha(item.approve_user_id)
          })
          if (response.data.result.length > 0) {
            const filteredData = response.data.result.reduce((acc, curr) => {
              const existingItem = acc.find(item => item.evaluate_salary_id === curr.evaluate_salary_id);
              if (!existingItem || curr.version > existingItem.version) {
                acc = acc.filter(item => item.evaluate_salary_id !== curr.evaluate_salary_id);
                acc.push(curr);
              }
              return acc;
            }, []);
            setEvaluateData(filteredData)
          } else {
            setEvaluateData(response.data.result);
          }
        })
        .catch(error => console.error("Error:", error));
    });
    // setTimeout(() => {
    //   setLoadingdata(false)
    // }, 3000);
  };

  const fetchEvaluateAdmin = async (order = "show_score", sort = "DESC", filtered = undefined, task = "") => {
    const urlCheckRound = `${API_URL}/api/evaluateSalary/checkRound`;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    await axios.get(urlCheckRound, config).then(async response => {
      setBudgetAndRound(response.data.result);
      const url = `${API_URL}/api/evaluateSalaryApprove/datatable`;
      let params;
      if (filtered === undefined) {
        params = new URLSearchParams({
          page: currentPage,
          size: 10,
          "order[0]": order,
          "order[1]": sort,
          "filter[budget_year][0]": response.data.result.this_budget_year,
          "filter[round][0]": response.data.result.this_round,
          "filter[approve_status][0]": 0,
        });
      } else {
        params = new URLSearchParams({
          page: currentPage,
          size: 10,
          "order[0]": order,
          "order[1]": sort,
          "filter[budget_year][0]": response.data.result.this_budget_year,
          "filter[round][0]": response.data.result.this_round,
          [`filter[${task}][0]`]: filtered,
        });
      }

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      await axios
        .get(url, config)
        .then(async response => {
          setDataInfo(() => response.data.info);
          setTotalPages(Math.ceil(response.data.info.totalRows / 10));

          const latestData = {};
          await response.data.result.forEach(item => {
            const { evaluate_salary_approve_id, evaluate_salary_id, ...rest } = item;
            if (!(evaluate_salary_id in latestData)) {
              latestData[evaluate_salary_id] = { evaluate_salary_approve_id, evaluate_salary_id, ...rest };
            } else {
              if (item.evaluate_salary_approve_id > latestData[evaluate_salary_id].evaluate_salary_approve_id) {
                latestData[evaluate_salary_id] = { evaluate_salary_approve_id, evaluate_salary_id, ...rest };
              }
            }
          });
          const result = Object.values(latestData);
          setEvaluateData(result);
          response.data.result.map(async item => {
            await fetchPositionLekha(item.approve_user_id)
            // await fecthStatus(item.user_id, item.budget_year, item.round)
          })
          setDataInfo(() => response.data.info);
          setTotalPages(Math.ceil(response.data.info.totalRows / 10));
        })
        .catch((error) => console.error("Error:", error));
    });

  };

  const alldata = async () => {
    setLoading(true);
    await fetchEvaluateApprove(userData.user_id);
    if (filterSubAdmin.length > 0 && conditon_for_admin) {
      if (Number(filterSubAdmin) === 0 || Number(filterSubAdmin) === 3) {
        await fetchEvaluateAdmin()
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        setTimeout(() => {
          setLoadingdata(false);
        }, 1000);
      } else {
        await fetchEvaluate(userData.user_id);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        setTimeout(() => {
          setLoadingdata(false);
        }, 1000);
      }
    } else {
      await fetchEvaluate(userData.user_id);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      setTimeout(() => {
        setLoadingdata(false);
      }, 1000);
    }

  }

  useEffect(() => {
    alldata()
  }, [dataSelect, roundYear, currentPage]);

  const handleButtonClick = (value) => {
    setLoading(true);
    if (value === "normal") {
      fetchEvaluate(userData.user_id);
    } else if (value === "admin") {
      fetchEvaluateAdmin()
    }

    setSectionFrom(false);
    setShowDataTable(true);
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  };

  const handleViewSwarp = (
    id,
    evaluate_salary_id,
    approve_user_id,
    user_department_id,
    year,
    round
  ) => {
    setEvaluateFormID(id);
    setUserYear(year);
    setUserRound(round);
    setEvaluateSalaryFormID(evaluate_salary_id);
    setApproveEvaluateuserID(approve_user_id);
    setDepartmentID(user_department_id);
    fetchLinkEvaluate(year, id, round, evaluate_salary_id)
  };

  const handleEditSwarp = (
    id,
    evaluate_salary_id,
    approve_user_id,
    evaluate_salary_approve_id,
    approve_user,
    version,
    check_sendback,
    evaluate_status
  ) => {
    setEvaluateFormID(id);
    setEvaluateSalaryFormID(evaluate_salary_id);
    setApproveEvaluateuserID(approve_user_id);
    setApproveEvaluateSalaryID(evaluate_salary_approve_id);
    setApprovUser(approve_user)
    setApprovVersion(version)
    setApprovSendback(check_sendback)
    setApprovrEvaluateStatus(evaluate_status)
  };

  const fetchStatusCheck = async (budget_year, user_id, round, evaluate_salary_id) => {
    const url = `${API_URL}/api/evaluateSalary/datatable`;
    const params = new URLSearchParams({ page: 1, size: 10, "order[0]": "evaluate_salary_id", "order[1]": "ASC", "filter[budget_year][0]": budget_year, "filter[round][0]": round, "filter[user_id][0]": user_id });
    const config = { headers: { Authorization: `Bearer ${token}` }, params, };
    await axios.get(url, config).then(response => {
      if (response.data.result.find(i => i.status === 4)) {
        const url_submit = `/api/evaluateSalary/${evaluate_salary_id}`;
        let data = { user_id: user_id, budget_year: budget_year, status: 2 };
        FetchAxiosPut(url_submit, data, token);
      }
    }).catch(error => console.error("Error:", error));
  }

  const fetchLinkEvaluate = async (budget_year, user_id, round, evaluate_salary_id) => {
    const url = `${API_URL}/api/evaluateSalary/datatable`;
    const params = new URLSearchParams({ page: 1, size: 10, "order[0]": "evaluate_salary_id", "order[1]": "ASC", "filter[budget_year][0]": budget_year, "filter[round][0]": round, "filter[user_id][0]": user_id });
    const config = { headers: { Authorization: `Bearer ${token}` }, params, };
    await axios.get(url, config).then(response => {
      setEvaluateSalaryLink(response.data.result[0].evaluate_url_ref)
    }).catch(error => console.error("Error:", error));
  }

  // const allEditSandBack = async (evaluate_salary_id) => {
  //   let params;
  //   const leaderNode = await fetchPositionId(userData.user_id, true)
  //   const check_leaderNode = Array.isArray(leaderNode) ? 
  //       leaderNode?.find(item => item.position_id === 3 || item.position_id === 4) 
  //       : (leaderNode.position_id === 3 || leaderNode.position_id === 4) && leaderNode
  //   const check_leka = Array.isArray(leaderNode) ? 
  //       leaderNode?.find(item => item.position_id === 2) 
  //       : (leaderNode.position_id === 2) && leaderNode

  //   params = new URLSearchParams({page: 1, size: 1000, "order[0]": "evaluate_salary_result_id", "order[1]": "DESC", "filter[evaluate_salary_id][0]": evaluate_salary_id});
  //   const result_data = await FetchAxiosGet("/api/evaluateSalaryResult/datatable",token,params)
  //   if (result_data?.result) {
  //     result_data?.result?.map(async (i, index) => {
  //         let data = {
  //           no: i.no,
  //           evaluate_salary_id: i.evaluate_salary_id,
  //           user_id: i.user_id,
  //           budget_year: i.budget_year,
  //           round: i.round,
  //           indicator: i.indicator,
  //           score_1: i.score_1,
  //           score_2: i.score_2,
  //           score_3: i.score_3,
  //           score_4: i.score_4,
  //           score_5: i.score_5,
  //           score: i.score,
  //           weight: i.weight,
  //           step_status: i.step_status,
  //           step_active: i.step_active
  //         };

  //         if (check_leaderNode) data.step_status = 2

  //         if (check_leka) data.step_status = 3

  //         if (check_leaderNode || check_leka) {
  //           const urlResult = `/api/evaluateSalaryResult/save`;
  //           await FetchAxiosPost(urlResult, data, token)
  //         }
  //     })
  //   }
  //   params.set("order[0]", "evaluate_salary_behavior_id");
  //   const behavior_data = await FetchAxiosGet("/api/evaluateSalaryBehavior/datatable",token,params)
  //   if (behavior_data) {
  //     behavior_data?.result?.map(async (i, index) => {
  //           let data = {
  //             evaluate_salary_id: i.evaluate_salary_id,
  //             user_id: i.user_id,
  //             budget_year: i.budget_year,
  //             round: i.round,
  //             no: i.no,
  //             score: i.score,
  //             step_status: i.step_status,
  //             step_active: i.step_active
  //           };

  //           if (check_leaderNode) data.step_status = 2

  //           if (check_leka) data.step_status = 3

  //           if (check_leaderNode || check_leka) {
  //           const urlBehavior = `/api/evaluateSalaryBehavior/save`;
  //             await FetchAxiosPost(urlBehavior, data, token)
  //           }
  //       })
  //   }

  //   params.set("order[0]", "evaluate_salary_development_id");
  //   const development_data = await FetchAxiosGet("/api/evaluateSalaryDevelopment/datatable",token,params)
  //   if (development_data) {
  //     development_data?.result?.map(async (i, index) => {
  //         const urlDevelopment = `/api/evaluateSalaryDevelopment/save`;
  //           let data = {
  //             evaluate_salary_id: i.evaluate_salary_id,
  //             user_id: i.user_id,
  //             budget_year: i.budget_year,
  //             round: i.round,
  //             no: i.id,
  //             development_type_id: i.topic,
  //             development: i.description,
  //             step_status: i.step_status,
  //             step_active: i.step_active
  //           };

  //           if (check_leaderNode) data.step_status = 2

  //           if (check_leka) data.step_status = 3

  //           if (check_leaderNode || check_leka) {
  //             await FetchAxiosPost(urlDevelopment, data, token)
  //           }
  //       })
  //   }

  // };

  const [valueCheck, setValueCheck] = useState(false)
  const handleCheck = async () => {
    // setLoadingdata(true);
    let positionid = null
    let valueCheckLet = false;
    checkboxApprov.forEach(async (i) => {
      // if (i.evaluate_status !== 5) {
      //   // await allEditFuction(2,i.evaluate_salary_id);
      //   // allEditSandBack()
      // }
      // allEditSandBack(i.evaluate_salary_id)

      if (i.evaluate_salary_approve_id) {
        const urlCheck = `/api/evaluateSalaryApprove/${i.evaluate_salary_approve_id}`;
        let dataapp = {
          approve_status: 1,
          evaluate_salary_id: i.evaluate_salary_id,
          user_id: i.user_id,
          budget_year: i.budget_year,
        };
        await FetchAxiosPut(urlCheck, dataapp, token);

        if (i.evaluate_status === 4) {
          const url_submit = `/api/evaluateSalary/${i.evaluate_salary_id}`;
          let data = {
            user_id: i.user_id,
            budget_year: i.budget_year,
            status: 2,
            check_sendback: 0,
          };
          await FetchAxiosPut(url_submit, data, token);
        }
        await fetchStatusCheck(i.budget_year, i.user_id, i.round, i.evaluate_salary_id)
        if (conditon_for_admin && filterSubAdmin.length > 0 && (Number(filterSubAdmin) === 0 || Number(filterSubAdmin) === 3)) {
          positionid = 9
        } else {
          await fetchPositionId(i.approve_user_id).then(resResult => {
            const url = `${API_URL}/api/evaluateSalaryHistory/datatable`;
            const params = new URLSearchParams({ page: 1, size: 1000, "order[0]": "evaluate_salary_history_id", "order[1]": "ASC", "filter[evaluate_salary_id][0]": i.evaluate_salary_id });
            const config = { headers: { Authorization: `Bearer ${token}` }, params };
            axios
              .get(url, config)
              .then(async response => {
                const url = "/api/evaluateSalaryHistory/save";
                let data
                let bool = true
                const alldataresult = response.data?.result
                if (alldataresult[alldataresult.length - 1].approve_user_id === i.approve_user_id) {
                  if (alldataresult[alldataresult.length - 1].approve_date !== null || alldataresult[alldataresult.length - 1].approve_date !== undefined) {
                    bool = false
                  }
                } else {
                  data = {
                    evaluate_salary_id: i.evaluate_salary_id,
                    seq: positionid !== null ? positionid : resResult,
                    first_score: alldataresult[alldataresult.length - 1].first_score,
                    second_score: alldataresult[alldataresult.length - 1].second_score,
                    total_score: alldataresult[alldataresult.length - 1].total_score,
                    approve_user_id: i.approve_user_id,
                    approve_user: i.approve_user,
                    status_history: 1
                  };
                }
                if (bool) {
                  // await FetchAxiosPost(url, data, token)
                }
              })
          })
        }
      }
      setValueCheck(true)
      // return valueCheckLet = true
    });
    setEvaluateData([])
  };

  useEffect(() => {
    if (valueCheck) {
      fetchEvaluate(userData.user_id);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  }, [valueCheck])

  const fetchPositionId = async (userid = null, next_org_lv = false, get_org = null) => {
    try {
      const url = `${API_URL}/api/users/position/datatable`;
      const params = new URLSearchParams({
        page: 1,
        size: 10,
        "order[0]": "position_id",
        "order[1]": "DESC",
        // "filter[assign][0]": "0",
        "filter[user_id][0]": userid,
        "filter[status][0]": 1,
      });
      if (get_org) {
        params.append("filter[org_id][0]", get_org)
      }
      if (!userid) {
        params.delete("filter[user_id][0]", userid)
      }
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };

      const response = await axios.get(url, config);

      if (response.data.result.length > 0) {
        const data = response.data.result.find(i => i.is_default);
        if (get_org) {
          return response.data.result
        } else if (next_org_lv) {
          if (data) {
            return data;
          } else if (response.data.result.length == 1) {
            return response.data.result
          }
        } else {
          if (data) {
            return data.position_id;
          } else if (response.data.result.length == 1) {
            return response.data.result.find(i => i.status == 1).position_id;
          }
        }
      } else {
        return 8;
      }
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  };

  const handleAccept = async () => {
    setLoading(true);
    let positionid = 9
    checkboxApprov.map(async i => {
      // await allEditFuction(3,i.evaluate_salary_id,i.budget_year);
      const urlCheck = `/api/evaluateSalary/${i.evaluate_salary_id}`;
      if (
        i.user_id !== null &&
        i.evaluate_salary_approve_id !== null &&
        i.evaluate_salary_id !== null &&
        i.budget_year !== null
      ) {
        let dataapp = {
          status: 5,
          budget_year: i.budget_year,
          user_id: i.user_id,
          witness_confirm: "1",
        };
        FetchAxiosPut(urlCheck, dataapp, token);
        const url = `${API_URL}/api/evaluateSalaryHistory/datatable`;
        const params = new URLSearchParams({
          page: 1,
          size: 10,
          "order[0]": "evaluate_salary_history_id",
          "order[1]": "ASC",
          "filter[evaluate_salary_id][0]": i.evaluate_salary_id,
        });
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params,
        };
        axios
          .get(url, config)
          .then(async response => {
            const url = "/api/evaluateSalaryHistory/save";
            let data
            let bool = true
            const alldataresult = response.data?.result
            response.data.result.map(item => {
              if (alldataresult[alldataresult.length - 1].approve_user_id === userData.user_id) {
                if (alldataresult[alldataresult.length - 1].approve_date !== null || alldataresult[alldataresult.length - 1].approve_date !== undefined) {
                  bool = false
                }
              } else {
                data = {
                  evaluate_salary_id: i.evaluate_salary_id,
                  seq: positionid,
                  first_score: item.first_score,
                  second_score: item.second_score,
                  total_score: item.total_score,
                  approve_user_id: userData.user_id,
                  approve_user: userData.user_name,
                  status_history: 1
                };
              }
            })
            if (bool) {
              // await FetchAxiosPost(url, data, token)
            }
          })
      }
    });
    fetchEvaluateAdmin()
    setTimeout(() => {
      setLoading(false);
    }, 3500);
  };

  const fetchPositionLekha = async (id) => {
    if (id !== null) {
      const url = `${API_URL}/api/users/position/datatable`;
      const params = new URLSearchParams({
        page: currentPage,
        size: 10,
        "order[0]": "position_id",
        "order[1]": "DESC",
        "filter[position_id][0]": 2,
        "filter[user_id][0]": id,
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      await axios
        .get(url, config)
        .then(response => {
          const mapUserid = response.data.result.map(i => i.user_id);
          const uniqueArray = [...new Set(mapUserid)]
          if (uniqueArray.length > 0) {
            setUserIdLekha(Number(uniqueArray))
          } else {

          }
        })
        .catch(error => console.error("Error:", error));
    }
  }

  const toggleModal = () => {
    setOpen(!open);
  };

  const [loadingHistory, setLoadingHistory] = useState(false);

  const historyEvaluate = async (id) => {
    setLoadingHistory(true)
    const urlCheckRound = `${API_URL}/api/evaluateSalary/checkRound`;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    await axios.get(urlCheckRound, config).then(response => {
      setBudgetAndRound(response.data.result);
      const url = `${API_URL}/api/evaluateSalaryHistory/datatable`;
      const params = new URLSearchParams({
        page: currentPage,
        size: 1000,
        "order[0]": "evaluate_salary_history_id",
        "order[1]": "ASC",
        "filter[evaluate_salary_id][0]": id,
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      axios
        .get(url, config)
        .then(async response => {
          const lastdata = response.data?.result[response.data?.result.length - 1]
          // await editHistory(lastdata.evaluate_salary_history_id, lastdata.evaluate_salary_id)
          // const maxVersion = Math.max(
          //     ...response.data.result.map(x => Number(x.version))
          // );
          
          // const latestVersionArray = response.data.result.filter(
          //     x => Number(x.version) === maxVersion
          // );
          setHistoryEvaluates(() => response.data?.result);
        })
        .catch((error) => console.error("Error:", error));
    });
    setLoadingHistory(false)
  }

  const editHistory = async (evaluate_salary_history_id, evaluate_salary_id) => {
    const urledit = `/api/evaluateSalaryHistory/${evaluate_salary_history_id}`;
    let data = { status_history: 0, evaluate_salary_id: evaluate_salary_id }
    await FetchAxiosPut(urledit, data, token);
    await fecthHistoryDataTable();
  }

  const fetchEvaluateApprove = async id => {
    const urlCheckRound = `${API_URL}/api/evaluateSalary/checkRound`;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    await axios.get(urlCheckRound, config).then(response => {
      setBudgetAndRound(response.data.result);
      const url = `${API_URL}/api/evaluateSalaryApprove/datatable`;
      const params = new URLSearchParams({
        page: currentPage,
        size: 10,
        "order[0]": "show_score",
        "order[1]": "DESC",
        "filter[budget_year][0]": response.data.result.this_budget_year,
        "filter[round][0]": response.data.result.this_round,
        "filter[user_id][0]": id,
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      axios
        .get(url, config)
        .then(response => {
          setUpdateApprove(() => response.data.result);
        })
        .catch((error) => console.error("Error:", error));
    });
  };

  useEffect(() => {
    let thisEffect = async () => {
      const orgInner = await FetchAxiosGet('/api/orgInner/level', token);
      let options = [{ value: '0', label: 'ทั้งหมด' }];
      await orgInner?.result?.child.map(async x => {
        options.push({ value: x.org_id, label: x.org_name })
        x.child && x.child.map(y => {
          options.push({ value: y.org_id, label: y.org_name })
          y.child && x.child.map(z => {
            options.push({ value: z.org_id, label: z.org_name })
          })
        })
      })
      options = options.filter((obj, index, self) => {
        return index === self.findIndex((t) => (
          t.value === obj.value
        ));
      });
      setOrgOptions(options)
    }

    let thisUseerAllEvaluate = async () => {
      const urlCheckRound = await FetchAxiosGet('/api/evaluateSalary/checkRound', token);
      const params = new URLSearchParams({ page: 1, size: 500, "order[0]": "user_name", "order[1]": "ASC", "filter[budget_year][0]": urlCheckRound.result.this_budget_year, "filter[round][0]": urlCheckRound.result.this_round });
      const alluserName = await FetchAxiosGet('/api/evaluateSalary/datatable', token, params);
      let options = [{ value: '0', label: 'ทั้งหมด' }];
      await alluserName?.result?.map(async x => {
        options.push({ value: x.user_id, label: x.user_name })
      })
      options = options.filter((obj, index, self) => {
        return index === self.findIndex((t) => (
          t.value === obj.value
        ));
      });
      setUserOpition(options)
    }
    thisUseerAllEvaluate()
    thisEffect()
  }, [])

  const toggleModalSort = () => {
    setKongSort(!kongSort)
  }

  const getDataSort = async (order = "show_score", sort = "DESC", value = undefined, task = "") => {
    if (value === "10") {
      setExportFilter({ order: "show_score", sort: "DESC", filtered: undefined, task: "" });
    } else {
      setExportFilter({ order, sort, filtered: value, task });
    }
    if (conditon_for_admin && filterSubAdmin.length > 0 && (Number(filterSubAdmin) === 0 || Number(filterSubAdmin) === 3)) {
      if (value === "10") {
        await fetchEvaluateAdmin()
      } else {
        await fetchEvaluateAdmin(order, sort, value, task)
      }
    } else {
      if (value === "10") {
        await fetchEvaluate(userData.user_id);
      } else {
        await fetchEvaluate(userData.user_id, order, sort, value, task);
      }
    }
  }

  const filterLevelStatus = async () => {
    setFilterLevel(!filterLevel);
  }

  // ดึงรายการทั้งหมดตามเงื่อนไข/ตัวกรองที่กำลังแสดงอยู่ (ไม่จำกัดเฉพาะหน้าปัจจุบัน) เพื่อนำไปออกไฟล์ Excel
  const buildExportParams = (checkRound, { order, sort, filtered, task }) => {
    const params = new URLSearchParams({
      page: 1,
      size: 1000,
      "order[0]": order,
      "order[1]": sort,
      "filter[budget_year][0]": checkRound.this_budget_year,
      "filter[round][0]": checkRound.this_round,
    });
    if (isAdminView) {
      if (filtered === undefined) {
        params.append("filter[approve_status][0]", 0);
      }
    } else {
      params.append("filter[approve_user_id][0]", userData.user_id);
    }
    if (filtered !== undefined) {
      params.append(`filter[${task}][0]`, filtered);
    }
    return params;
  };

  // ยุบข้อมูลให้เหลือรายการล่าสุดของแต่ละ evaluate_salary_id เหมือนกับที่ตารางแสดงผล
  const dedupeExportRows = rows => {
    if (isAdminView) {
      const latestData = {};
      rows.forEach(item => {
        const existing = latestData[item.evaluate_salary_id];
        if (!existing || item.evaluate_salary_approve_id > existing.evaluate_salary_approve_id) {
          latestData[item.evaluate_salary_id] = item;
        }
      });
      return Object.values(latestData);
    }
    return rows.reduce((acc, curr) => {
      const existing = acc.find(item => item.evaluate_salary_id === curr.evaluate_salary_id);
      if (!existing || curr.version > existing.version) {
        return [...acc.filter(item => item.evaluate_salary_id !== curr.evaluate_salary_id), curr];
      }
      return acc;
    }, []);
  };

  // แถวจาก evaluateSalaryApprove/datatable อาจไม่มี user_trial ติดมาด้วย
  // จึงเติมจาก /api/users/datatable ก่อนส่งออก เพราะใช้กำหนดน้ำหนัก 70/30 หรือ 50/50
  const fillUserTrial = async rows => {
    if (rows.every(item => item.user_trial !== undefined)) return rows;
    try {
      const params = new URLSearchParams({
        page: 1,
        size: 2000,
        "order[0]": "user_id",
        "order[1]": "ASC",
      });
      const response = await FetchAxiosGet("/api/users/datatable", token, params);
      const trialByUserId = new Map(
        (response?.result ?? []).map(user => [String(user.user_id), user.user_trial])
      );
      return rows.map(item => ({
        ...item,
        user_trial: item.user_trial ?? trialByUserId.get(String(item.user_id)),
      }));
    } catch (error) {
      console.error("Error:", error);
      return rows;
    }
  };

  const handleExportExcel = async () => {
    setExportLoading(true);
    try {
      const checkRound = await FetchAxiosGet("/api/evaluateSalary/checkRound", token);
      const params = buildExportParams(checkRound.result, exportFilter);
      const response = await FetchAxiosGet("/api/evaluateSalaryApprove/datatable", token, params);
      const visibleRows = dedupeExportRows(response?.result ?? []).filter(
        item => item.approve_status != 2 || (isAdminView && item.approve_status === "2")
      );
      // ส่งออกทุกรายการที่แสดงอยู่ในตารางเสมอ ไม่ขึ้นกับการติ๊กเลือก
      exportEvaluateExcel(await fillUserTrial(visibleRows), {
        budgetYear: checkRound.result.this_budget_year,
        round: checkRound.result.this_round,
      });
    } catch (error) {
      console.error("Error:", error);
    }
    setExportLoading(false);
  };

  const dropdown = [
    {
      values: "10",
      label: "ทั้งหมด"
    },
    {
      values: "0",
      label: "ไม่มีข้อมูล"
    },
    {
      values: "1",
      label: "บันทึกร่าง"
    },
    {
      values: "2",
      label: "รอรับการประเมิน"
    },
    {
      values: "3",
      label: "เสร็จสิ้นการประเมิน"
    },
    {
      values: "4",
      label: "ส่งกลับ"
    },
    {
      values: "5",
      label: "ผ่านคณะกรรมการกลั่นกรอง"
    },
    {
      values: "9",
      label: "เข้าคณะกรรมการกลั่นกรอง"
    },
  ]

  useEffect(() => {
    if (userInfo) {
      if (
        (!CheckPosition(userPosition) &&
          !CheckSubAdmin(userData?.positionSubAdmin)) && !(userInfo?.user_new_id === 9)
      ) {
        navigate("/assessment");
      }
    }
  }, [userInfo]);

  const allCheckedValue = (conditions) => {
    if (evaluateData.length > 0) {
      evaluateData.map((i, index) => {
        if (((!(i.approve_status == 1 || i.sendback_status == 0) || (filterSubAdmin.length > 0 && (Number(filterSubAdmin) === 0 || Number(filterSubAdmin) === 3))) && i.status != 5) || (i.status == 5 && userIdLekha == userData.user_id)) {
          const isUserSelected = conditions && i.user_id !== null;
          const isApproveUserSelected = conditions && i.approve_user_id !== null;
          const isEvaluateSalarySelected = conditions && i.evaluate_salary_id !== null;
          if (conditions) {
            setCheckButtonAcceptArray(prev => [...new Set([...prev, i.user_id])])
          } else {
            setCheckButtonAcceptArray(prev => prev.filter(x => x !== i.user_id))
          }
          if (isUserSelected || isApproveUserSelected || isEvaluateSalarySelected) {
            let newOBJ = {
              user_id: isUserSelected ? i.user_id : null,
              evaluate_salary_approve_id: isApproveUserSelected ? i.evaluate_salary_approve_id : null,
              evaluate_salary_id: isEvaluateSalarySelected ? i.evaluate_salary_id : null,
              budget_year: isEvaluateSalarySelected ? i.budget_year : null,
              round: isEvaluateSalarySelected ? i.round : null,
              approve_user_id: isApproveUserSelected ? i.approve_user_id : null,
              approve_user: isApproveUserSelected ? i.approve_user : null,
              evaluate_status: isApproveUserSelected ? i.evaluate_status : null
            };
            setCheckboxApprov(prev => [...prev.filter(x => x.user_id !== i.user_id), newOBJ]);
          } else {
            setCheckboxApprov(prev => prev.filter(x => x.user_id !== i.user_id));
          }
        }
      })
    }
  }


  return (
    <Fragment>
      {loading ? (
        <LoadingPage />
      ) : showDataTable ? (
        <FadeIn>
          <FadeIn>
            <div className="">
              <Container fluid>
                <Breadcrumb
                  title="หน้าหลัก"
                  breadcrumbItem="การประเมินผลการปฏิบัติราชการ"
                  breadcrumbText={`${(CheckSubAdmin(userInfo?.positionSubAdmin).length > 0) && conditon_for_admin
                    && ((CheckSubAdmin(userInfo?.positionSubAdmin).includes(0) || CheckSubAdmin(userInfo?.positionSubAdmin).includes(3)))
                    ? "การประเมินผู้ใต้บังคับบัญชา" : "การประเมินผู้ใต้บังคับบัญชาของตนเอง"} รอบการประเมินที่ ${budgetAndRound.this_round ?? "..."} ปี ${budgetAndRound.this_budget_year ?? "..."}`}
                  isBack={false}
                  isSubMenu={true}
                  subMenuName={`${(CheckSubAdmin(userInfo?.positionSubAdmin).length > 0) && conditon_for_admin
                    && ((CheckSubAdmin(userInfo?.positionSubAdmin).includes(0) || CheckSubAdmin(userInfo?.positionSubAdmin).includes(3)))
                    ? "การประเมินผู้ใต้บังคับบัญชา" : "การประเมินผู้ใต้บังคับบัญชาของตนเอง"} รอบการประเมินที่ ${budgetAndRound.this_round ?? "..."} ปี ${budgetAndRound.this_budget_year ?? "..."}`}
                  path="/assessment/?menu=subordinate"
                />
                <Table
                  className="align-middle" striped
                  style={{ overflow: "scroll" }}
                  responsive
                >
                  <thead className="table-light" style={{ whiteSpace: "nowrap", fontSize: "15px" }}>
                    <tr>
                      <th>
                        <Input
                          type="checkbox"
                          addon
                          disabled={loadingdata || ((filterSubAdmin.length > 0 && (Number(filterSubAdmin) === 0 || Number(filterSubAdmin) === 3)) && evaluateData.filter((i) => i.status == 5).length == evaluateData.length)}
                          checked={
                            checkButtonAcceptArray.length > 0 &&
                            (evaluateData.filter((i) => ((!(i.approve_status == 1 || i.sendback_status == 0) ||
                              (filterSubAdmin.length > 0 && (Number(filterSubAdmin) === 0 || Number(filterSubAdmin) === 3))) && i.status != 5) || (i.status == 5 && userIdLekha == userData.user_id)
                            ).length == checkButtonAcceptArray.length)
                          }
                          onClick={(e) => allCheckedValue(!e.target.checked)}
                        />
                      </th>
                      <th>ลำดับ</th>
                      <th
                        className="text-center"
                        onMouseEnter={(e) => e.target.style.backgroundColor = "rgba(215,218,222,0.6)"}
                        onMouseLeave={(e) => e.target.style.backgroundColor = "rgba(239,242,247,1)"}
                        onClick={() => { toggleModalSort(); setFilterSection(0) }}
                        style={{
                          verticalAlign: "middle",
                          whiteSpace: "nowrap",
                          cursor: "pointer",
                          transition: "background-color 0.3s",
                        }}
                      >
                        ชื่อ สกุล <i className="ps-1 fa-solid fa-magnifying-glass"></i>
                        <div className="mt-1 fs-6 text-danger"> *สามารถค้นหารายชื่อได้* </div>
                      </th>
                      <th
                        onMouseEnter={(e) => e.target.style.backgroundColor = "rgba(215,218,222,0.6)"}
                        onMouseLeave={(e) => e.target.style.backgroundColor = "rgba(239,242,247,1)"}
                        onClick={() => { toggleModalSort(); setFilterSection(1) }}
                        style={{ cursor: "pointer" }}
                      >
                        สำนักงาน/กอง/กลุ่ม <i className="ps-1 fa-duotone fa-filter-list"></i>
                      </th>
                      <th>ตำแหน่ง </th>
                      <th>คะแนนประเมิน ( % )</th>
                      <th>ระดับการประเมิน</th>
                      <th>
                        <Row>
                          <Col lg={4} className="me-1">สถานะ</Col>
                          {/* <Col>
                            <Dropdown isOpen={filterLevel} toggle={() => filterLevelStatus()}>
                              <DropdownToggle className="p-0 btn btn-outline-dark" caret color="light">
                                <i className="mdi mdi-chevron-down" />
                              </DropdownToggle>
                              <DropdownMenu>
                                {dropdown.map((i, idx) => {
                                  return (
                                    <Fragment key={idx}>
                                      <DropdownItem value={i.values} onClick={(e) => getDataSort(undefined, undefined, e.target.value, "status")}>{i.label}</DropdownItem>
                                    </Fragment>
                                  )
                                })}
                              </DropdownMenu>
                            </Dropdown>
                          </Col> */}
                        </Row>
                      </th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>

                  {loadingdata ?
                    <tbody className="border boder-dark text-center">
                      <tr>
                        <td colSpan="10" className="text-center fs-5">
                          <LoadingData />
                        </td>
                      </tr>
                    </tbody>
                    :
                    <tbody style={{ whiteSpace: "nowrap", fontSize: "15px" }}>
                      {evaluateData.length === 0 ? (
                        <tr>
                          <td colSpan="10" className="text-center fs-5">
                            ไม่มีข้อมูล
                          </td>
                        </tr>
                      ) : (
                        <Fragment>
                          {evaluateData.map((i, index) => {
                            let cp = (currentPage - 1) * 10;

                            const scoreLevelConfig = getScoreLevelConfig(i);
                            
                            const thisEvaluate = i.evaluateSalaryData
                            
                            return i.approve_status != 2 || (conditon_for_admin && filterSubAdmin.length > 0 && (Number(filterSubAdmin) === 0 || Number(filterSubAdmin) === 3) && i.approve_status === "2") ? (
                              <tr key={index}>
                                <td>
                                  {
                                    i.approve_status == 1 || i.sendback_status === "0" ?
                                      // i.approve_status === 0 ?
                                      conditon_for_admin && filterSubAdmin.length > 0 && (Number(filterSubAdmin) == 0 || Number(filterSubAdmin) == 3) && i.witness_confirm === null && i.status == 9 ?
                                        <Input
                                          addon
                                          type="checkbox"
                                          checked={checkButtonAcceptArray.includes(i.user_id) || false}
                                          onClick={e => {
                                            const isChecked = !e.target.checked;
                                            const isUserSelected = isChecked && i.user_id !== null;
                                            const isApproveUserSelected = isChecked && i.approve_user_id !== null;
                                            const isEvaluateSalarySelected = isChecked && i.evaluate_salary_id !== null;
                                            if (isChecked) {
                                              setCheckButtonAcceptArray(prev => [...new Set([...prev, i.user_id])])
                                            } else {
                                              setCheckButtonAcceptArray(prev => prev.filter(x => x !== i.user_id))
                                            }
                                            if (isUserSelected || isApproveUserSelected || isEvaluateSalarySelected) {
                                              let newOBJ = {
                                                user_id: isUserSelected ? i.user_id : null,
                                                evaluate_salary_approve_id: isApproveUserSelected ? i.evaluate_salary_approve_id : null,
                                                evaluate_salary_id: isEvaluateSalarySelected ? i.evaluate_salary_id : null,
                                                budget_year: isEvaluateSalarySelected ? i.budget_year : null,
                                                round: isEvaluateSalarySelected ? i.round : null,
                                                approve_user_id: isApproveUserSelected ? i.approve_user_id : null,
                                                approve_user: isApproveUserSelected ? i.approve_user : null,
                                                evaluate_status: isApproveUserSelected ? i.evaluate_status : null
                                              };

                                              setCheckboxApprov(prev => [...prev.filter(x => x.user_id !== i.user_id), newOBJ]);
                                            } else {
                                              setCheckboxApprov(prev => prev.filter(x => x.user_id !== i.user_id));
                                            }
                                          }}
                                        />
                                        : <Input addon type="checkbox" disabled />
                                      : i.approve_status == 2 ?
                                        <Input addon type="checkbox" disabled />
                                        : (((i.witness_confirm === null || i.approve_status === "0") && i.status != 5) || (i.status == 5 && userIdLekha == userData.user_id)) ?
                                          <Input
                                            addon
                                            type="checkbox"
                                            checked={checkButtonAcceptArray.includes(i.user_id) || false}
                                            onClick={e => {
                                              const isChecked = !e.target.checked;
                                              const isUserSelected = isChecked && i.user_id !== null;
                                              const isApproveUserSelected = isChecked && i.approve_user_id !== null;
                                              const isEvaluateSalarySelected = isChecked && i.evaluate_salary_id !== null;
                                              if (isChecked) {
                                                setCheckButtonAcceptArray(prev => [...new Set([...prev, i.user_id])])
                                              } else {
                                                setCheckButtonAcceptArray(prev => prev.filter(x => x !== i.user_id))
                                              }
                                              if (isUserSelected || isApproveUserSelected || isEvaluateSalarySelected) {
                                                let newOBJ = {
                                                  user_id: isUserSelected ? i.user_id : null,
                                                  evaluate_salary_approve_id: isApproveUserSelected ? i.evaluate_salary_approve_id : null,
                                                  evaluate_salary_id: isEvaluateSalarySelected ? i.evaluate_salary_id : null,
                                                  budget_year: isEvaluateSalarySelected ? i.budget_year : null,
                                                  round: isEvaluateSalarySelected ? i.round : null,
                                                  approve_user_id: isApproveUserSelected ? i.approve_user_id : null,
                                                  approve_user: isApproveUserSelected ? i.approve_user : null,
                                                  evaluate_status: isApproveUserSelected ? i.evaluate_status : null
                                                };
                                                setCheckboxApprov(prev => [...prev.filter(x => x.user_id !== i.user_id), newOBJ]);
                                              } else {
                                                setCheckboxApprov(prev => prev.filter(x => x.user_id !== i.user_id));
                                              }
                                            }}
                                          /> : <Input addon type="checkbox" disabled />
                                  }
                                </td>
                                <td>{index + 1 + cp}</td>
                                <td>
                                  <span>{i.user_name}</span>
                                </td>
                                <td>
                                  <span>{i.cont_to}</span>
                                </td>
                                <td>
                                  <span>{i.user_position_name}</span>
                                </td>
                                <td className="text-center">
                                  <span>
                                    {thisEvaluate?.show_score === null || thisEvaluate?.show_score === undefined
                                    ? "0.00"
                                    : Number(thisEvaluate?.show_score).toFixed(2)}
                                  </span>
                                </td>
                                <td>
                                  {scoreLevelConfig && <Badge color={scoreLevelConfig.color} className="p-2 bg-opacity-10">
                                    <span className={`text-${scoreLevelConfig.color} fs-6`}>
                                      {scoreLevelConfig.text}
                                    </span>
                                  </Badge>}
                                </td>
                                <td>
                                  {checkEvaluateStaus(i.status)}
                                </td>
                                <td>
                                  {(i.approve_status == 1 && filterSubAdmin.length === 0 && i.witness_confirm === null) || (i.sendback_status === "0") || i.status == 3 ||
                                    (conditon_for_admin && filterSubAdmin.length > 0 && (Number(filterSubAdmin) == 0 || Number(filterSubAdmin) == 3) && i.witness_confirm == 1 &&
                                      (i.status != 9 || i.status == 3 || i.status == 5)) || (i.created_user_id === userIdLekha)
                                    ? (
                                      <Button
                                        color="info"
                                        onClick={() => {
                                          handleViewSwarp(
                                            i.user_id,
                                            i.evaluate_salary_id,
                                            i.approve_user_id,
                                            i.user_department_id,
                                            i.budget_year,
                                            i.round,
                                          );
                                          setSectionViewFrom(true);
                                          setShowDataTable(false);
                                        }}
                                      >
                                        <i className="fa-solid fa-magnifying-glass me-2"></i>
                                        ดูข้อมูล
                                      </Button>
                                    ) : (
                                      ""
                                    )}
                                  {(i.approve_status == 0 && i.sendback_status !== "0" && i.witness_confirm === null && i.created_user_id !== userIdLekha) ||
                                    (conditon_for_admin && filterSubAdmin.length > 0 && (Number(filterSubAdmin) == 0 || Number(filterSubAdmin) == 3) &&
                                      i.witness_confirm === null && (i.status == 9 && i.status != 3 && i.status != 5) || (i.status == 5 && userIdLekha == userData.user_id)
                                    ) ? (
                                    <Button
                                      color="success"
                                      onClick={() => {
                                        handleEditSwarp(
                                          i.user_id,
                                          i.evaluate_salary_id,
                                          i.approve_user_id,
                                          i.evaluate_salary_approve_id,
                                          i.approve_user,
                                          i.version,
                                          i.sendback_status,
                                          i.evaluate_status,
                                        );
                                        setSectionEditFrom(true);
                                        setShowDataTable(false);
                                      }}
                                    >
                                      <i className="fa-solid fa-check-to-slot me-2"></i>
                                      ประเมิน
                                    </Button>
                                  ) : (
                                    ""
                                  )}
                                </td>
                                <td>
                                  <Button className="mt-1 position-relative beat-container"
                                    onClick={async () => {
                                      toggleModal();
                                      setEvaluateDataItem(i)
                                      setThisEvaluateUserId(i.user_id)
                                      await historyEvaluate(i.evaluate_salary_id);
                                    }}
                                    color="warning">
                                    <i className="fa-sharp fa-solid fa-bullseye-pointer me-2"></i> ประวัติคะแนน
                                    {historyDataTable?.length > 0 &&
                                      Number((historyDataTable.filter(itemBox => Number(itemBox?.evaluate_salary_id) === i.evaluate_salary_id)
                                      [historyDataTable.filter(itemBox => Number(itemBox?.evaluate_salary_id) === i.evaluate_salary_id).length - 1]?.status_history)) === 1
                                      ? (
                                        <div className="translate-middle position-absolute top-0 start-100">
                                          <Badge color="danger" pill className="beat">
                                            ใหม่
                                          </Badge>
                                        </div>
                                      ) : ""}
                                  </Button>
                                </td>
                              </tr>
                            ) : (
                              ""
                            )
                          })}
                        </Fragment>
                      )}
                    </tbody>}
                </Table>
                <div className="d-flex flex-wrap align-items-center gap-2 my-2">
                  {conditon_for_admin && filterSubAdmin.length > 0 ?
                    (Number(filterSubAdmin) === 0 || Number(filterSubAdmin) === 3) &&
                    <Button
                      color="success"
                      disabled={evaluateData.length === 0 || checkButtonAcceptArray.length === 0}
                      onClick={async () => {
                        setConfirmModal(true);
                        setConfirmModalState("ADMIN")
                      }}
                    >
                      <i className="fa-duotone fa-check-double pe-2"></i>
                      อนุมัติรายการที่เลือก
                    </Button>
                    :
                    <Button
                      color="primary"
                      disabled={evaluateData.length === 0 || checkButtonAcceptArray.length === 0}
                      onClick={async () => {
                        setConfirmModal(true);
                        setConfirmModalState("ANOTHER")
                      }}
                    >
                      <i className="fa-duotone fa-check-double pe-2"></i>
                      อนุมัติการประเมินที่เลือก
                    </Button>
                  }
                  <Button
                    color="success"
                    // outline
                    disabled={loadingdata || exportLoading || evaluateData.length === 0}
                    onClick={handleExportExcel}
                  >
                    {exportLoading ? (
                      <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
                    ) : (
                      <i className="fa-solid fa-file-excel me-2"></i>
                    )}
                    Export Excel
                  </Button>
                </div>
                <ConfirmModal
                  modal={confirmModal}
                  modalSize="md"
                  modalHeaderContent={"ต้องการที่จะอนุมัติ ใช่หรือไม่?"}
                  onClickConfirmBtn={async () => {
                    // console.log(confirmModalState);
                    // console.log(userInfo);

                    // if (confirmModalState === "ADMIN") {//จวนทำไว้ให้กลั่นกรอง
                    //     await handleAccept();
                    // } else
                    // if (confirmModalState === "ANOTHER") {
                    setLoading(true);
                    await handleCheck()
                    // }
                    setConfirmModal(false)
                    setCheckButtonAcceptArray([])
                  }}
                  onClickCancelBtn={() => {
                    setConfirmModal(false)
                  }}
                />
                <Row>
                  <Col className="d-flex justify-content-center justify-content-sm-end">
                    <Pagination className="mt-3">
                      <PaginationItem disabled={currentPage === 1}>
                        <PaginationLink onClick={() => setCurrentPage(1)}>
                          หน้าแรก
                        </PaginationLink>
                      </PaginationItem>
                      <PaginationItem disabled={currentPage === 1}>
                        <PaginationLink
                          onClick={() => setCurrentPage(currentPage - 1)}
                        >
                          ย้อนกลับ
                        </PaginationLink>
                      </PaginationItem>
                      <PaginationItem active>
                        <PaginationLink>หน้า {currentPage}</PaginationLink>
                      </PaginationItem>
                      <PaginationItem
                        disabled={
                          currentPage === dataInfo.totalPage || totalPages === 0
                        }
                      >
                        <PaginationLink
                          onClick={() =>
                            setCurrentPage(dataInfo.currentPage + 1)
                          }
                        >
                          ถัดไป
                        </PaginationLink>
                      </PaginationItem>
                      <PaginationItem
                        disabled={
                          currentPage === totalPages || totalPages === 0
                        }
                      >
                        <PaginationLink
                          onClick={() => setCurrentPage(dataInfo.totalPage)}
                        >
                          หน้าสุดท้าย
                        </PaginationLink>
                      </PaginationItem>
                    </Pagination>
                  </Col>
                </Row>
              </Container>
            </div>
          </FadeIn>
        </FadeIn>
      ) : loading ? (
        <LoadingPage />
      ) : sectionFrom === true ? (
        <FadeIn>
          <EvaluateForm
            onButtonClick={handleButtonClick}
            user_id={evaluateFormID}
            approve_user_id={approveEvaluateuserID}
            evaluate_salary_id={evaluateSalaryFormID}
            budget_year={dataSelect}
            round={roundYear}
          />

          <Button
            className="mb-3 mt-0"
            color="info"
            onClick={() => {
              setSectionFrom(false);
              setShowDataTable(true);
              handleButtonClick('normal')
            }}
          >
            กลับไปหน้าแรก
          </Button>
        </FadeIn>
      ) : sectionViewFrom === true ? (
        <FadeIn>
          <ViewEvaluate
            onButtonClick={handleButtonClick}
            user_id={evaluateFormID}
            approve_user_id={approveEvaluateuserID}
            evaluate_salary_id={evaluateSalaryFormID}
            budget_year={userYear}
            round={userRound}
            updateApprove={updateApprove[0]}
            evaluateLink={evaluateSalaryLink}
          />

          <Button
            className="mb-3 mt-0"
            color="info"
            onClick={() => {
              setSectionViewFrom(false);
              setShowDataTable(true);
              handleButtonClick('normal')
            }}
          >
            กลับไปหน้าแรก
          </Button>
        </FadeIn>
      ) : sectionEditFrom === true ? (
        <FadeIn>
          <EditEvaluateForm
            onButtonClick={handleButtonClick}
            user_id={evaluateFormID}
            approve_user_id={approveEvaluateuserID}
            evaluate_salary_id={evaluateSalaryFormID}
            budget_year={budgetAndRound.this_budget_year}
            round={budgetAndRound.this_round}
            evaluate_salary_approve_id={approveEvaluateSalaryID}
            approve_user={approvUser}
            version={approvVersion}
            checkSendback={approvSendback}
            conditon_for_admin={conditon_for_admin}
            evaluate_status={approvEvaluateStatus}
          />

          <Button
            className="mb-3 mt-0"
            color="info"
            onClick={() => {
              setSectionEditFrom(false);
              setShowDataTable(true);
              handleButtonClick('normal')
            }}
          >
            กลับไปหน้าแรก
          </Button>
        </FadeIn>
      ) : (
        ""
      )}
      <HistoryEvaluate open={open} toggle={toggleModal} data={historyEvaluates}  evaluateData={evaluateDataItem} thisEvaluateUserId={thisEvaluateUserId} loading={loadingHistory}/>
      {filterSection === 0 && <SortEvaluate openSort={kongSort} toggleSort={toggleModalSort} data={userOpition} getData={getDataSort} prefixAndPlachoder={"เจ้าหน้าที่"} headers={"เจ้าหน้าที่"} task={"user_id"} />}
      {filterSection === 1 && <SortEvaluate openSort={kongSort} toggleSort={toggleModalSort} data={orgOptions} getData={getDataSort} prefixAndPlachoder={"สำนักงาน/กอง/กลุ่ม"} headers={"สำนักงาน/กอง/กลุ่ม"} task={"cont_to_id"} />}
      {/*filterSection === 2 && <SortEvaluate openSort={kongSort} toggleSort={toggleModalSort} data={evaluatePosition} getData={getDataSort} prefixAndPlachoder = {"ตำแหน่ง"} headers={"ตำแหน่ง"}/>*/}

    </Fragment>
  );
}
export default TabledataCommander;
